var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8342 2.83325C12.8342 3.93782 11.9388 4.83325 10.8342 4.83325C9.72966 4.83325 8.83423 3.93782 8.83423 2.83325C8.83423 1.72868 9.72966 0.833252 10.8342 0.833252C11.9388 0.833252 12.8342 1.72868 12.8342 2.83325Z",
    stroke: "#2D3740",
    strokeWidth: 0.825
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.83423 6.49988C4.83423 7.60445 3.9388 8.49988 2.83423 8.49988C1.72966 8.49988 0.834229 7.60445 0.834229 6.49988C0.834229 5.39531 1.72966 4.49988 2.83423 4.49988C3.9388 4.49988 4.83423 5.39531 4.83423 6.49988Z",
    stroke: "#2D3740",
    strokeWidth: 0.825
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8342 10.1666C12.8342 11.2712 11.9388 12.1666 10.8342 12.1666C9.72966 12.1666 8.83423 11.2712 8.83423 10.1666C8.83423 9.06206 9.72966 8.16663 10.8342 8.16663C11.9388 8.16663 12.8342 9.06206 12.8342 10.1666Z",
    stroke: "#2D3740",
    strokeWidth: 0.825
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.65323 5.66639L8.98656 3.66675M4.65323 7.33341L8.98656 9.33306",
    stroke: "#2D3740",
    strokeWidth: 0.825
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.dc565d66037675408575d80a9fef9b16.svg";
export { ForwardRef as ReactComponent };